import { useState } from "react";
import { Play, X } from "lucide-react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { Reveal } from "./Reveal";
import { trackEvent } from "@/lib/analytics";

const POSTER = "https://images.pexels.com/photos/13012915/pexels-photo-13012915.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600";
const VIDEO_URL = "https://customer-assets.emergentagent.com/job_sabbath-way/artifacts/jbqnisus_Have%20We%20Left%20Christ%E2%80%99s%20Original%20Gospel.mp4";

export const Watch = () => {
  const [open, setOpen] = useState(false);

  return (
    <section id="watch" data-testid="watch-section" className="bg-[#0A0A0A] py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal>
          <p className="text-xs font-semibold tracking-[0.3em] uppercase text-[#D4AF37] mb-4">
            Hear the Message
          </p>
          <h2 className="font-heading font-light tracking-tight text-4xl md:text-6xl max-w-3xl leading-tight mb-12">
            Watch the <span className="italic text-[#D4AF37]">restoration</span> proclaimed.
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <button
            data-testid="watch-video-trigger"
            onClick={() => { setOpen(true); trackEvent("play_video", { label: "Featured Teaching" }); }}
            className="group relative block w-full overflow-hidden border border-[#2B2825]"
          >
            <div className="relative aspect-video">
              <img
                src={POSTER}
                alt="Watch the message"
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-[#0A0A0A]/55 group-hover:bg-[#0A0A0A]/40 transition-colors" />
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="flex h-20 w-20 md:h-24 md:w-24 items-center justify-center border border-[#D4AF37] bg-[#0A0A0A]/40 backdrop-blur-sm text-[#D4AF37] transition-transform duration-500 group-hover:scale-110">
                  <Play strokeWidth={1} className="h-8 w-8 md:h-10 md:w-10 translate-x-0.5" fill="currentColor" />
                </span>
              </div>
              <div className="absolute bottom-6 left-6 md:bottom-8 md:left-8 text-left">
                <p className="font-mono text-xs tracking-[0.2em] uppercase text-[#D4AF37] mb-2">
                  Featured Teaching
                </p>
                <p className="font-heading text-2xl md:text-3xl font-light text-[#F4F0EA]">
                  Have We Left Christ&rsquo;s Original Gospel?
                </p>
              </div>
            </div>
          </button>
        </Reveal>
      </div>

      <DialogPrimitive.Root open={open} onOpenChange={setOpen}>
        <DialogPrimitive.Portal>
          <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-black/90 backdrop-blur-sm data-[state=open]:animate-in data-[state=open]:fade-in-0" />
          <DialogPrimitive.Content
            data-testid="watch-video-modal"
            className="fixed left-1/2 top-1/2 z-50 w-[92vw] max-w-5xl -translate-x-1/2 -translate-y-1/2 focus:outline-none data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95"
          >
            <DialogPrimitive.Title className="sr-only">Featured Teaching Video</DialogPrimitive.Title>
            <DialogPrimitive.Description className="sr-only">
              Video: Have We Left Christ's Original Gospel
            </DialogPrimitive.Description>
            <DialogPrimitive.Close
              data-testid="watch-video-close"
              className="absolute -top-12 right-0 flex items-center gap-2 text-[#A39E98] hover:text-[#F4F0EA] transition-colors"
            >
              <span className="text-sm tracking-wide">Close</span>
              <X strokeWidth={1} className="h-5 w-5" />
            </DialogPrimitive.Close>
            <div className="aspect-video w-full border border-[#4A453F] bg-black">
              {open && (
                <video
                  data-testid="watch-video-player"
                  className="h-full w-full"
                  src={VIDEO_URL}
                  controls
                  autoPlay
                  playsInline
                />
              )}
            </div>
          </DialogPrimitive.Content>
        </DialogPrimitive.Portal>
      </DialogPrimitive.Root>
    </section>
  );
};
